import { z } from 'zod';

import {
  type TagsAnalysisResponse,
  tagsAnalysisResponseSchema,
} from '@/features/performance-dashboard/schemas/tagsAnalysis';
import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';

export const getBenchmarkingAnaliseApontamentosParamsSchema = z.object({
  escolaId: z.number().int(),
  anoLetivo: z.number().int().optional(),
  anoEscolarId: z.number().int().optional(),
  turmaId: z.number().int().optional(),
  alunoId: z.number().int().optional(),
  categoriaId: z.number().int().optional(),
  nomModelo: z.string().optional(),
  eixoId: z.number().int().optional(),
  generoId: z.number().int().optional(),
  size: z.number().int().optional(),
});

export type GetBenchmarkingAnaliseApontamentosParams = z.infer<typeof getBenchmarkingAnaliseApontamentosParamsSchema>;

export const getBenchmarkingAnaliseApontamentos = httpGetAdapter<
  TagsAnalysisResponse,
  GetBenchmarkingAnaliseApontamentosParams
>({
  url: (params) => `/v3/microdados/escola/${params.escolaId}/analise-apontamentos`,
  schema: tagsAnalysisResponseSchema,
  mapParams: ({ escolaId: _escolaId, ...rest }) => rest,
});
